import type {
  OrganisationAdminStatus,
  OrganisationMembershipStatus,
  OrganisationSeatKind,
} from '@dreamai/types';

export const SEAT_LABELS: Record<OrganisationSeatKind, string> = {
  assistant: 'Secretary',
  directory: 'Directory only',
};

export const SEAT_DESCRIPTIONS: Record<OrganisationSeatKind, string> = {
  assistant: 'Has their own Dream secretary',
  directory: 'Listed for scheduling; no secretary',
};

/**
 * Seat kinds an admin may pick for a new invitation or when editing a member.
 * "Directory only" is not offered for now; existing directory-only members
 * are still shown with their current seat and can be moved to an assistant.
 */
export function selectableSeatKinds(
  current?: OrganisationSeatKind,
): OrganisationSeatKind[] {
  return current === 'directory' ? ['assistant', 'directory'] : ['assistant'];
}

export const STATUS_LABELS: Record<OrganisationMembershipStatus, string> = {
  invited: 'Invited',
  declined: 'Declined',
  active: 'Active',
  deactivated: 'Deactivated',
};

export const ADMIN_STATUS_LABELS: Record<OrganisationAdminStatus, string> = {
  invited: 'Invited',
  active: 'Active',
  removed: 'Removed',
};

export function formatDate(iso: string | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatLastActive(iso: string | undefined): string {
  if (!iso) return 'Never';
  const then = new Date(iso);
  const days = Math.floor((Date.now() - then.getTime()) / 86_400_000);
  if (days <= 0) return 'Today';
  if (days === 1) return 'Yesterday';
  if (days < 7) return `${days} days ago`;
  return formatDate(iso);
}

export function apiErrorMessage(err: unknown, fallback: string): string {
  const axiosErr = err as {
    response?: { data?: { error?: string; message?: string } };
  };
  return (
    axiosErr?.response?.data?.error ||
    axiosErr?.response?.data?.message ||
    fallback
  );
}
